const DISCOUNT_CODE = {
  CODE_COPIED: 'Code copied successfully.',
  AMOUNT_SELECTION: 'Please select amount.',
} as const;

export default DISCOUNT_CODE;
